function pgTrybeCheckoutUrl(destination, search) {
  try {
    const code = new URLSearchParams(search).get('trybe');
    if (!code || code.length > 2048 || /[\u0000-\u001f\u007f]/.test(code)) return destination;
    const url = new URL(destination);
    if (url.protocol !== 'https:' || url.hostname !== 'pilatesflo.com' || url.port || url.username || url.password) return destination;
    if (!/^\/(?:cart(?:\/|$)|checkouts(?:\/|$))/.test(url.pathname) || url.searchParams.has('trybe')) return destination;
    url.searchParams.set('trybe', code);
    return url.href;
  } catch (_) {
    return destination;
  }
}

(function (window, document) {
  "use strict";

  var EVENT_TYPES = [
    "quiz_start", "screen_view", "answer", "back", "result_view",
    "cta_click", "offer_interaction", "quiz_complete", "quiz_error"
  ];
  var ATTR_KEYS = [
    "utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term",
    "fbclid", "ttclid", "gclid"
  ];
  var MAX_QUEUE = 1000;
  var MAX_ATTEMPTS = 5;
  var RETRY_COOLDOWN_MS = 60 * 1000;
  var QUEUE_TTL_MS = 24 * 60 * 60 * 1000;
  var FLUSH_MS = 2000;
  var sdkScript = document.currentScript;
  var sdkOrigin = null;
  try { sdkOrigin = sdkScript && new URL(sdkScript.src).origin; } catch (_) {}

  var state = {
    config: null,
    endpoint: null,
    sessionId: null,
    sessionToken: null,
    sessionExpiresAt: null,
    sequence: 0,
    queue: [],
    flushing: false,
    initPromise: null,
    initAttempts: 0,
    clientSessionKey: null,
    createdAt: null,
    retryAt: 0,
    failures: 0,
    blocked: null,
    dropped: 0,
    legacyPending: 0,
    lastSuccessAt: null,
    ownershipReady: true,
    ownershipPromise: null,
    releaseOwnership: null,
    ownershipWarning: null,
    storageWarning: null,
    deliveryFailures: 0,
    diagnosticSignature: null,
    onceEvents: {},
    timer: null
    ,assignments: []
    ,answers: {}
    ,reconcilers: []
  };

  function uuid() {
    if (window.crypto && typeof window.crypto.randomUUID === "function") {
      return window.crypto.randomUUID();
    }
    var bytes = new Uint8Array(16);
    if (window.crypto && window.crypto.getRandomValues) window.crypto.getRandomValues(bytes);
    else for (var i = 0; i < bytes.length; i++) bytes[i] = Math.floor(Math.random() * 256);
    bytes[6] = (bytes[6] & 15) | 64;
    bytes[8] = (bytes[8] & 63) | 128;
    var hex = Array.prototype.map.call(bytes, function (b) { return b.toString(16).padStart(2, "0"); }).join("");
    return hex.slice(0, 8) + "-" + hex.slice(8, 12) + "-" + hex.slice(12, 16) + "-" + hex.slice(16, 20) + "-" + hex.slice(20);
  }

  function storageGet(storage, key) {
    try { return storage.getItem(key); } catch (_) { state.storageWarning = "browser_storage_unavailable"; return null; }
  }

  function browserStorage(name) {
    try { return window[name]; } catch (_) { state.storageWarning = "browser_storage_unavailable"; return null; }
  }

  function storageSet(storage, key, value) {
    try { storage.setItem(key, value); } catch (_) { state.storageWarning = "browser_storage_unavailable"; }
  }

  function storageRemove(storage, key) {
    try { storage.removeItem(key); } catch (_) {}
  }

  function trafficSuffix() { return state.config.isTest ? "_qa" : ""; }
  function queueKey() { return "nyquiz_queue_v2_" + state.config.quizKey + "_" + state.config.versionKey + trafficSuffix(); }
  function sessionKey() { return "nyquiz_session_" + state.config.quizKey + "_" + state.config.versionKey + trafficSuffix(); }

  function getHealth() {
    return {
      status: state.blocked ? "blocked" : state.failures || state.dropped || state.legacyPending || state.ownershipWarning || state.storageWarning ? "degraded" : "collecting",
      reason: state.blocked,
      ownershipWarning: state.ownershipWarning,
      storageWarning: state.storageWarning,
      pending: state.queue.length,
      dropped: state.dropped,
      legacyPending: state.legacyPending,
      failures: state.failures,
      retryAt: state.retryAt || null,
      lastSuccessAt: state.lastSuccessAt,
      sessionId: state.sessionId
    };
  }

  function publishHealth() {
    try { window.dispatchEvent(new CustomEvent("nyquiz:health", { detail: getHealth() })); } catch (_) {}
  }

  function loadQueue() {
    // The old localStorage queue has no session ownership. Never replay it into
    // a new visit. Leave it untouched and expose the unresolved legacy count.
    var legacy = storageGet(browserStorage("localStorage"), "nyquiz_queue_" + state.config.quizKey + "_" + state.config.versionKey);
    try { state.legacyPending = legacy ? JSON.parse(legacy).length : 0; } catch (_) {}
    var raw = storageGet(browserStorage("sessionStorage"), queueKey());
    if (!raw) return [];
    try {
      var now = Date.now();
      var saved = JSON.parse(raw);
      if (saved.owner !== state.clientSessionKey || !Array.isArray(saved.entries)) {
        state.blocked = "queue_owner_mismatch";
        return [];
      }
      state.dropped = Number(saved.dropped || 0);
      state.deliveryFailures = Number(saved.deliveryFailures || 0);
      state.diagnosticSignature = saved.diagnosticSignature || null;
      var current = saved.entries.filter(function (entry) {
        var valid = entry && entry.event && now - Number(entry.queuedAt || 0) <= QUEUE_TTL_MS;
        if (!valid) state.dropped += 1;
        return valid;
      });
      if (current.length > MAX_QUEUE) state.dropped += current.length - MAX_QUEUE;
      return current.slice(0, MAX_QUEUE);
    } catch (_) { return []; }
  }

  function saveQueue() {
    storageSet(browserStorage("sessionStorage"), queueKey(), JSON.stringify({
      owner: state.clientSessionKey, sessionId: state.sessionId,
      entries: state.queue, dropped: state.dropped,
      deliveryFailures: state.deliveryFailures, diagnosticSignature: state.diagnosticSignature
    }));
    publishHealth();
  }

  function visitorId() {
    var key = "nyquiz_visitor_id";
    var value = storageGet(browserStorage("localStorage"), key);
    if (!value) {
      value = uuid();
      storageSet(browserStorage("localStorage"), key, value);
    }
    return value;
  }

  // Only report after the collector can communicate. Failures remain durable in
  // the visit queue until recovery; diagnostics never claim a live health check.
  function reportDiagnostics() {
    var detail = {
      code: "collector_delivery_diagnostic",
      recoveredFailures: state.deliveryFailures,
      droppedEvents: state.dropped,
      legacyUnownedEvents: state.legacyPending,
      storageWarning: state.storageWarning,
      ownershipWarning: state.ownershipWarning
    };
    if (!detail.recoveredFailures && !detail.droppedEvents && !detail.legacyUnownedEvents &&
        !detail.storageWarning && !detail.ownershipWarning) return;
    var signature = JSON.stringify([detail.droppedEvents, detail.legacyUnownedEvents,
      detail.storageWarning, detail.ownershipWarning]);
    if (!detail.recoveredFailures && signature === state.diagnosticSignature) return;
    if (state.queue.length >= MAX_QUEUE) return;
    state.deliveryFailures = 0;
    state.diagnosticSignature = signature;
    track("quiz_error", { properties: detail });
  }

  function attribution() {
    var out = {};
    var configured = state.config && state.config.attribution;
    var params;
    try { params = new URLSearchParams(window.location.search); } catch (_) { params = null; }
    ATTR_KEYS.forEach(function (key) {
      var storageKey = "nyquiz_attr_" + key;
      var incoming = (params && params.get(key)) || (configured && configured[key]);
      if (incoming) storageSet(browserStorage("sessionStorage"), storageKey, incoming);
      out[key] = incoming || storageGet(browserStorage("sessionStorage"), storageKey) || null;
    });
    return out;
  }

  function assignmentToken() {
    if (state.config && state.config.assignmentToken) return state.config.assignmentToken;
    try { return new URLSearchParams(window.location.search).get("nyq_assignment"); }
    catch (_) { return null; }
  }

  function sanitizedLandingUrl() {
    if (state.config && state.config.landingUrl) return state.config.landingUrl;
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete("nyq_assignment");
      return url.toString();
    } catch (_) { return window.location.href; }
  }

  function removeAssignmentTokenFromAddressBar() {
    try {
      var url = new URL(window.location.href);
      if (!url.searchParams.has("nyq_assignment")) return;
      url.searchParams.delete("nyq_assignment");
      window.history.replaceState(window.history.state, "", url.toString());
    } catch (_) {}
  }

  function publishAssignments() {
    try {
      window.dispatchEvent(new CustomEvent("nyquiz:assignment", { detail: state.assignments.slice() }));
    } catch (_) {}
    if (state.config && typeof state.config.onAssignment === "function") {
      try { state.config.onAssignment(state.assignments.slice()); } catch (_) {}
    }
  }

  function publishRuntimeConfig() {
    try {
      window.dispatchEvent(new CustomEvent("nyquiz:config", {
        detail: {
          activeVersionKey: state.config.activeVersionKey || state.config.versionKey,
          resultLogic: state.config.resultLogic || null,
          results: Array.isArray(state.config.results) ? state.config.results.slice() : [],
          destinationUrl: state.config.destinationUrl || null
        }
      }));
    } catch (_) {}
  }

  function deviceType() {
    var width = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    return width <= 767 ? "mobile" : width <= 1024 ? "tablet" : "desktop";
  }

  function endpoint(path) {
    return state.endpoint.replace(/\/$/, "") + path + "?quizKey=" + encodeURIComponent(state.config.quizKey);
  }

  function post(path, body, keepalive) {
    return window.fetch(endpoint(path), {
      method: "POST",
      mode: "cors",
      credentials: "omit",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
      keepalive: Boolean(keepalive)
    }).then(function (response) {
      if (!response.ok) {
        var error = new Error("Quiz collector returned " + response.status);
        error.status = response.status;
        throw error;
      }
      return response.json();
    });
  }

  function restoreSession() {
    var raw = storageGet(browserStorage("sessionStorage"), sessionKey());
    if (!raw) return false;
    try {
      var saved = JSON.parse(raw);
      if ((saved.createdAt && Date.now() - Number(saved.createdAt) >= QUEUE_TTL_MS) ||
          (!saved.clientSessionKey && saved.expiresAt && Number(saved.expiresAt) <= Date.now())) {
        archiveExpiredVisit(saved.clientSessionKey || saved.sessionId || "legacy");
        return false;
      }
      state.clientSessionKey = saved.clientSessionKey || uuid();
      state.createdAt = Number(saved.createdAt || Date.now());
      state.sessionId = saved.sessionId || null;
      state.sessionToken = Number(saved.expiresAt) > Date.now() ? saved.sessionToken : null;
      state.sessionExpiresAt = Number(saved.expiresAt);
      state.sequence = Number(saved.sequence || 0);
      state.assignments = Array.isArray(saved.assignments) ? saved.assignments : [];
      state.answers = saved.answers && typeof saved.answers === "object" ? saved.answers : {};
      state.onceEvents = saved.onceEvents && typeof saved.onceEvents === "object" ? saved.onceEvents : {};
      state.config.activeVersionKey = saved.activeVersionKey || state.config.versionKey;
      state.config.resultLogic = saved.resultLogic || null;
      state.config.results = Array.isArray(saved.results) ? saved.results : [];
      if (saved.destinationUrl) state.config.destinationUrl = saved.destinationUrl;
      return Boolean(state.sessionToken);
    } catch (_) { return false; }
  }

  function archiveExpiredVisit(owner) {
    var pending = storageGet(browserStorage("sessionStorage"), queueKey());
    if (pending) {
      storageSet(browserStorage("sessionStorage"), queueKey() + "_expired_" + owner, pending);
      try { state.dropped += Math.max(state.queue.length, JSON.parse(pending).entries.length); } catch (_) { state.dropped += state.queue.length; }
    } else state.dropped += state.queue.length;
    storageRemove(browserStorage("sessionStorage"), queueKey());
    storageRemove(browserStorage("sessionStorage"), sessionKey());
    state.queue = [];
    state.sessionId = null;
    state.sessionToken = null;
    state.sessionExpiresAt = null;
    state.clientSessionKey = uuid();
    state.createdAt = Date.now();
    state.sequence = 0;
    state.answers = {};
    state.onceEvents = {};
    state.assignments = [];
    state.initAttempts = 0;
    state.failures = 0;
    state.retryAt = 0;
    state.blocked = null;
    publishHealth();
  }

  function saveSession(expiresInSeconds) {
    if (expiresInSeconds) state.sessionExpiresAt = Date.now() + Number(expiresInSeconds) * 1000;
    storageSet(browserStorage("sessionStorage"), sessionKey(), JSON.stringify({
      clientSessionKey: state.clientSessionKey,
      createdAt: state.createdAt,
      sessionId: state.sessionId,
      sessionToken: state.sessionToken,
      sequence: state.sequence,
      assignments: state.assignments,
      answers: state.answers,
      onceEvents: state.onceEvents,
      activeVersionKey: state.config.activeVersionKey || null,
      resultLogic: state.config.resultLogic || null,
      results: Array.isArray(state.config.results) ? state.config.results : [],
      destinationUrl: state.config.destinationUrl || null,
      expiresAt: state.sessionExpiresAt
    }));
  }

  function ensureSession() {
    if (!state.config) return Promise.resolve(null);
    if (!state.ownershipReady) return state.ownershipPromise.then(ensureSession);
    if (state.sessionExpiresAt && Date.now() >= state.sessionExpiresAt) state.sessionToken = null;
    if (state.sessionToken) return Promise.resolve(state.sessionId);
    if (state.blocked || Date.now() < state.retryAt) return Promise.resolve(null);
    if (state.initPromise) return state.initPromise;
    saveSession();
    state.initPromise = post("/api/quiz-collect/session", {
      clientSessionKey: state.clientSessionKey,
      versionKey: state.config.versionKey,
      isTest: state.config.isTest === true,
      visitorId: visitorId(),
      landingUrl: sanitizedLandingUrl(),
      referrer: document.referrer || null,
      attribution: attribution(),
      deviceType: deviceType(),
      deviceContext: {
        collectorVersion: "1.5.0",
        legacyUnownedEvents: state.legacyPending,
        storageWarning: state.storageWarning,
        ownershipWarning: state.ownershipWarning,
        viewportWidth: window.innerWidth || null,
        viewportHeight: window.innerHeight || null,
        language: window.navigator.language || null,
        timezone: (window.Intl && Intl.DateTimeFormat().resolvedOptions().timeZone) || null
      },
      noticeVersion: state.config.noticeVersion || null,
      fwExperimentId: state.config.fwExperimentId || null,
      experimentKey: state.config.experimentKey || null,
      variantKey: state.config.variantKey || null
      ,assignmentToken: assignmentToken()
    }).then(function (response) {
      if (state.sessionId && response.sessionId !== state.sessionId) {
        state.blocked = "session_owner_mismatch";
        throw new Error("Collector cannot move queued events to another session");
      }
      state.sessionId = response.sessionId;
      state.sessionToken = response.sessionToken;
      state.initAttempts = 0;
      state.failures = 0;
      state.retryAt = 0;
      state.assignments = Array.isArray(response.assignments) ? response.assignments : [];
      state.config.activeVersionKey = response.activeVersionKey || state.config.versionKey;
      if (Object.prototype.hasOwnProperty.call(response, "resultLogic")) {
        state.config.resultLogic = response.resultLogic || null;
      }
      if (Array.isArray(response.results)) state.config.results = response.results;
      if (response.destinationUrl) state.config.destinationUrl = response.destinationUrl;
      saveSession(response.expiresInSeconds);
      removeAssignmentTokenFromAddressBar();
      publishAssignments();
      publishRuntimeConfig();
      saveQueue();
      reportDiagnostics();
      try { window.dispatchEvent(new CustomEvent("nyquiz:session", { detail: { sessionId: state.sessionId } })); } catch (_) {}
      state.initPromise = null;
      flush();
      return state.sessionId;
    }).catch(function (error) {
      state.initPromise = null;
      if (error && error.status === 410) {
        if (state.releaseOwnership) { state.releaseOwnership(); state.releaseOwnership = null; }
        archiveExpiredVisit(state.clientSessionKey);
        saveSession();
        saveQueue();
        claimOwnership();
        window.setTimeout(ensureSession, 0);
        return null;
      }
      state.initAttempts += 1;
      state.failures += 1;
      state.deliveryFailures += 1;
      if (error && [400, 401, 403, 404, 409].indexOf(error.status) >= 0) state.blocked = "session_rejected_" + error.status;
      var delay = state.initAttempts >= MAX_ATTEMPTS ? RETRY_COOLDOWN_MS : Math.pow(2, state.initAttempts - 1) * 1000;
      state.retryAt = Date.now() + delay;
      if (!state.blocked) window.setTimeout(ensureSession, delay);
      saveQueue();
      return null;
    });
    return state.initPromise;
  }

  function publicEvent(entry) {
    return entry.event;
  }

  function nextBatch() {
    var batch = [];
    for (var i = 0; i < state.queue.length && batch.length < 50; i++) {
      var candidate = batch.concat(state.queue[i]);
      // Keepalive has a browser byte limit as well as the server's 64 KiB cap.
      var bytes = new Blob([JSON.stringify({ sessionToken: state.sessionToken, events: candidate.map(publicEvent) })]).size;
      if (bytes > 60 * 1024) break;
      batch = candidate;
    }
    if (!batch.length && state.queue.length) { state.blocked = "event_payload_too_large"; publishHealth(); }
    return batch;
  }

  function flush() {
    reconcileNow();
    if (!state.config || state.blocked || Date.now() < state.retryAt || state.flushing || !state.queue.length) return Promise.resolve(false);
    return ensureSession().then(function (sessionId) {
      if (!sessionId || state.flushing) return false;
      var batch = nextBatch();
      if (!batch.length) return false;
      state.flushing = true;
      return post("/api/quiz-collect/events", {
        sessionToken: state.sessionToken,
        events: batch.map(publicEvent)
      }, true).then(function () {
        var sent = {};
        batch.forEach(function (entry) { sent[entry.event.eventId] = true; });
        state.queue = state.queue.filter(function (entry) { return !sent[entry.event.eventId]; });
        state.failures = 0;
        state.retryAt = 0;
        state.lastSuccessAt = new Date().toISOString();
        reportDiagnostics();
        saveQueue();
        state.flushing = false;
        if (state.queue.length) window.setTimeout(flush, 0);
        return true;
      }).catch(function (error) {
        state.failures += 1;
        state.deliveryFailures += 1;
        state.flushing = false;
        if (error && error.status === 401) {
          state.sessionToken = null;
          state.sessionExpiresAt = null;
          saveSession();
        }
        if (error && [400, 403, 404, 409, 413].indexOf(error.status) >= 0) state.blocked = "events_rejected_" + error.status;
        var delay = state.failures >= MAX_ATTEMPTS ? RETRY_COOLDOWN_MS : Math.pow(2, state.failures) * 1000;
        state.retryAt = Date.now() + delay;
        saveQueue();
        if (!state.blocked) window.setTimeout(flush, delay);
        return false;
      });
    });
  }

  function track(type, data, onceKey) {
    if (!state.config || EVENT_TYPES.indexOf(type) < 0) return null;
    if (onceKey && state.ownershipReady && state.onceEvents[onceKey]) return state.onceEvents[onceKey];
    data = data || {};
    if (state.queue.length >= MAX_QUEUE) {
      state.dropped += 1;
      saveQueue();
      return null;
    }
    state.sequence += 1;
    var event = {
      eventId: uuid(),
      sequence: state.sequence,
      type: type,
      occurredAt: new Date().toISOString()
    };
    ["screenKey", "questionKey", "answerValue", "answerLabel", "resultKey", "properties"].forEach(function (key) {
      if (Object.prototype.hasOwnProperty.call(data, key) && data[key] !== undefined) event[key] = data[key];
    });
    if (type === "answer" && data.questionKey && Object.prototype.hasOwnProperty.call(data, "answerValue")) {
      state.answers[data.questionKey] = data.answerValue;
    }
    state.queue.push({ event: event, queuedAt: Date.now(), onceKey: onceKey || null });
    if (onceKey && state.ownershipReady) state.onceEvents[onceKey] = event.eventId;
    saveQueue();
    saveSession();
    if (state.queue.length >= 5) flush();
    return event.eventId;
  }

  function identify(data) {
    if (!state.config) return Promise.resolve(false);
    data = data || {};
    return ensureSession().then(function (sessionId) {
      if (!sessionId) return false;
      return post("/api/quiz-collect/identity", {
        sessionToken: state.sessionToken,
        firstName: data.firstName || null,
        lastName: data.lastName || null,
        email: data.email || null,
        phone: data.phone || null,
        externalCustomerId: data.externalCustomerId || null,
        noticeVersion: data.noticeVersion || state.config.noticeVersion || null
      }).then(function () { return true; }).catch(function () { return false; });
    });
  }

  // Duplicate-tab can copy sessionStorage. A browser lock prevents two live
  // documents from writing the same visit, while a reload resumes that visit.
  function claimOwnership() {
    var inheritedSequence = state.sequence;
    state.ownershipReady = false;
    state.ownershipPromise = new Promise(function (resolve) {
      function forkVisit() {
        // Keep only events created by this document after init. The other
        // tab still owns the copied pending events and their original IDs.
        state.queue = state.queue.filter(function (entry) { return entry.event.sequence > inheritedSequence; });
        state.clientSessionKey = uuid();
        state.sessionId = null;
        state.sessionToken = null;
        state.sessionExpiresAt = null;
        state.createdAt = Date.now();
        state.sequence = 0;
        state.answers = {};
        state.assignments = [];
        state.onceEvents = {};
        state.queue.forEach(function (entry) {
          entry.event.sequence = ++state.sequence;
          if (entry.event.type === "answer") state.answers[entry.event.questionKey] = entry.event.answerValue;
        });
        inheritedSequence = 0;
        state.dropped = 0;
        state.deliveryFailures = 0;
        state.diagnosticSignature = null;
        saveSession();
        saveQueue();
      }
      function settleVisit() {
        state.ownershipReady = true;
        state.ownershipWarning = null;
        // Only newly queued events need once-per-visit deduplication. An
        // inherited pending event must still be delivered after a reload.
        state.queue = state.queue.filter(function (entry) {
          if (!entry.onceKey || entry.event.sequence <= inheritedSequence) return true;
          if (state.onceEvents[entry.onceKey]) return false;
          state.onceEvents[entry.onceKey] = entry.event.eventId;
          return true;
        });
        saveSession();
        saveQueue();
      }
      // BroadcastChannel retains reload continuity on browsers without Web
      // Locks. A live owner answers a probe; simultaneous probes elect one
      // document deterministically before any request or delivery is allowed.
      function broadcastClaim() {
        if (typeof window.BroadcastChannel !== "function") {
          state.ownershipWarning = "tab_ownership_not_supported";
          state.ownershipReady = true;
          publishHealth(); resolve(); return;
        }
        var channel, timer, documentId = uuid();
        function leave() { if (timer) window.clearTimeout(timer); if (channel) channel.close(); }
        function forkAndClaim() { leave(); forkVisit(); broadcastClaim(); }
        try {
          channel = new window.BroadcastChannel("nyquiz_visit_" + state.clientSessionKey);
          channel.onmessage = function (message) {
            var data = message.data || {};
            if (data.id === documentId) return;
            if (data.type === "probe") {
              if (state.ownershipReady || documentId < data.id) channel.postMessage({type:"owner",id:documentId,target:data.id});
              else forkAndClaim();
            } else if (data.type === "owner" && data.target === documentId && !state.ownershipReady) forkAndClaim();
          };
          state.releaseOwnership = leave;
          channel.postMessage({type:"probe",id:documentId});
          timer = window.setTimeout(function () { settleVisit(); resolve(); }, 200);
        } catch (_) {
          leave(); state.ownershipReady = true; state.ownershipWarning = "tab_ownership_check_failed"; publishHealth(); resolve();
        }
      }
      if (!window.navigator.locks || typeof window.navigator.locks.request !== "function") {
        broadcastClaim(); return;
      }
      function claim() {
        window.navigator.locks.request("nyquiz_visit_" + state.clientSessionKey, { ifAvailable: true }, function (lock) {
          if (!lock) {
            forkVisit();
            return claim();
          }
          settleVisit();
          resolve();
          return new Promise(function (release) { state.releaseOwnership = release; });
        }).catch(function () {
          state.ownershipReady = true;
          state.ownershipWarning = "tab_ownership_check_failed";
          publishHealth();
          resolve();
        });
      }
      claim();
    });
  }

  function init(config) {
    if (!config || !config.quizKey || !config.versionKey) return Promise.resolve(null);
    if (state.config) {
      if (state.config.quizKey === config.quizKey && state.config.versionKey === config.versionKey) return ensureSession();
      state.blocked = "collector_reinitialized_for_another_quiz";
      publishHealth();
      return Promise.resolve(null);
    }
    state.config = config;
    try { state.config.isTest = config.isTest === true || new URLSearchParams(window.location.search).get("nyq_test") === "1"; } catch (_) {}
    state.endpoint = config.endpoint || sdkOrigin || window.location.origin;
    var restored = restoreSession();
    if (!state.clientSessionKey) state.clientSessionKey = uuid();
    if (!state.createdAt) state.createdAt = Date.now();
    state.queue = loadQueue();
    saveSession();
    claimOwnership();
    publishHealth();
    if (!state.timer) state.timer = window.setInterval(flush, FLUSH_MS);
    var promise = ensureSession();
    if (restored) window.setTimeout(function () {
      publishAssignments();
      publishRuntimeConfig();
    }, 0);
    return promise;
  }

  function beaconFlush() {
    reconcileNow();
    if (!state.config || !state.ownershipReady || !state.sessionToken || !state.queue.length || !window.navigator.sendBeacon) return;
    if (state.blocked) return;
    var batch = nextBatch();
    if (!batch.length) return;
    try {
      var body = JSON.stringify({ sessionToken: state.sessionToken, events: batch.map(publicEvent) });
      window.navigator.sendBeacon(endpoint("/api/quiz-collect/events"), new Blob([body], { type: "text/plain" }));
    } catch (_) {}
  }

  window.addEventListener("online", function () {
    if (state.blocked) return;
    state.initAttempts = 0;
    state.failures = 0;
    state.retryAt = 0;
    ensureSession().then(flush);
  });
  window.addEventListener("pagehide", function () {
    beaconFlush();
    if (state.releaseOwnership) { state.releaseOwnership(); state.releaseOwnership = null; }
  });
  window.addEventListener("pageshow", function (event) {
    if (event.persisted && state.config) { claimOwnership(); ensureSession().then(flush); }
  });
  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "hidden") beaconFlush();
  });

  function getAssignments() { return state.assignments.slice(); }

  function getSessionId() { return state.sessionId || null; }

  function registerReconciler(reconciler) {
    if (typeof reconciler !== "function") return false;
    state.reconcilers.push(reconciler);
    return true;
  }

  function reconcileNow() {
    state.reconcilers.forEach(function (reconciler) {
      try { reconciler(); } catch (_) {}
    });
  }

  function sameValue(left, right) {
    if (left === undefined) return false;
    if ((left && typeof left === "object") || (right && typeof right === "object")) {
      try { return JSON.stringify(left) === JSON.stringify(right); } catch (_) { return false; }
    }
    return left === right;
  }

  function containsValue(answer, expected) {
    if (answer === undefined || answer === null) return false;
    if (Array.isArray(answer)) return answer.some(function (item) { return sameValue(item, expected); });
    return typeof answer === "string" && typeof expected === "string" && answer.indexOf(expected) >= 0;
  }

  function conditionMatches(condition, answers) {
    var answer = answers[condition.questionKey];
    if (answer === undefined) return false;
    if (condition.operator === "equals") return sameValue(answer, condition.value);
    if (condition.operator === "not_equals") return !sameValue(answer, condition.value);
    if (condition.operator === "contains") return containsValue(answer, condition.value);
    if (condition.operator === "not_contains") return !containsValue(answer, condition.value);
    return false;
  }

  function resolveResult(answers) {
    var logic = state.config && state.config.resultLogic;
    if (!logic || !Array.isArray(logic.rules)) return null;
    var values = answers || state.answers;
    for (var index = 0; index < logic.rules.length; index += 1) {
      var rule = logic.rules[index];
      if (!rule || !Array.isArray(rule.conditions) || !rule.conditions.length) continue;
      var matches = rule.match === "any"
        ? rule.conditions.some(function (condition) { return conditionMatches(condition, values); })
        : rule.conditions.every(function (condition) { return conditionMatches(condition, values); });
      if (matches) return rule.resultKey || null;
    }
    return logic.fallbackResultKey || null;
  }

  function getResult(answers) {
    var key = resolveResult(answers);
    var results = state.config && Array.isArray(state.config.results) ? state.config.results : [];
    for (var index = 0; index < results.length; index += 1) {
      if (results[index] && results[index].key === key) return results[index];
    }
    return key ? { key: key, label: key } : null;
  }

  function getAnswers() {
    var copy = {};
    Object.keys(state.answers).forEach(function (key) { copy[key] = state.answers[key]; });
    return copy;
  }

  window.NyQuiz = {
    init: init,
    track: track,
    trackOnce: function (type, data) { return track(type, data, type); },
    identify: identify,
    flush: flush,
    getAssignments: getAssignments,
    getSessionId: getSessionId,
    getHealth: getHealth,
    getAnswers: getAnswers,
    registerReconciler: registerReconciler,
    reconcileNow: reconcileNow,
    resolveResult: resolveResult,
    getResult: getResult,
    version: "1.5.0"
  };
})(window, document);

import {ReferenceFlow} from './pg-reference-state-20d1346e5f70.js';

const app=document.querySelector('#pg-lasta-app');
const definition=await fetch(app.dataset.flowUrl).then(r=>{if(!r.ok)throw Error('Flow definition unavailable');return r.json();});
const flow=new ReferenceFlow(definition);
const annualResumeConfig={"versionKey": "pg-06dce696b2a583f0", "sourceUrl": "https://pilatesguide.org/pages/4-week-pilates", "resultScreens": ["s28"], "completeScreens": ["s28"], "quizKey": "pg-lasta", "screens": [{"key": "s01", "type": "single", "label": "Find your starting point for Mat Pilates", "questionKey": "s01", "question": "Find your starting point for Mat Pilates", "options": [{"key": "male", "label": "Male"}, {"key": "female", "label": "Female"}]}, {"key": "s02", "type": "information", "label": "Make today the start of your routine"}, {"key": "s03", "type": "multi", "label": "What do you want to gain?", "questionKey": "s03", "question": "What do you want to gain?", "options": [{"key": "o1", "label": "Lose weight"}, {"key": "o2", "label": "Improve overall fitness"}, {"key": "o3", "label": "Get firm and toned"}, {"key": "o4", "label": "Build a consistent routine"}]}, {"key": "s04", "type": "information", "label": "Make room for your whole routine"}, {"key": "s05", "type": "single", "label": "Which description fits your build today?", "questionKey": "s05", "question": "Which description fits your build today?", "options": [{"key": "slim", "label": "Slim"}, {"key": "o1", "label": "Mid-sized"}, {"key": "o2", "label": "On a heavier side"}, {"key": "o3", "label": "Overweight"}]}, {"key": "s06", "type": "single", "label": "Which shape best reflects your personal goal?", "questionKey": "s06", "question": "Which shape best reflects your personal goal?", "options": [{"key": "o1", "label": "Thin"}, {"key": "o2", "label": "Toned"}, {"key": "o3", "label": "Curvy"}]}, {"key": "s07", "type": "information", "label": "Start with one session"}, {"key": "s08", "type": "single", "label": "Have you followed a workout plan before?", "questionKey": "s08", "question": "Have you followed a workout plan before?", "options": [{"key": "o1", "label": "Yes, I practice them regularly"}, {"key": "o2", "label": "Yes, I've tried them"}, {"key": "o3", "label": "No, I have never tried them"}]}, {"key": "s09", "type": "information", "label": "Make the next session easier to come back to"}, {"key": "s10", "type": "single", "label": "Which pattern sounds most like your experience?", "questionKey": "s10", "question": "Which pattern sounds most like your experience?", "options": [{"key": "o1", "label": "I have trouble gaining muscle or body fat"}, {"key": "o2", "label": "I gain and lose weight without effort"}, {"key": "o3", "label": "I gain weight easily but find it hard to lose"}]}, {"key": "s11", "type": "single", "label": "How easily do you bend?", "questionKey": "s11", "question": "How easily do you bend?", "options": [{"key": "o1", "label": "Pretty Flexible"}, {"key": "o2", "label": "Just getting started"}, {"key": "o3", "label": "Not that good"}, {"key": "o4", "label": "Not sure"}]}, {"key": "s12", "type": "single", "label": "How regularly do you train?", "questionKey": "s12", "question": "How regularly do you train?", "options": [{"key": "o1", "label": "Almost every day"}, {"key": "o2", "label": "Several times per week"}, {"key": "o3", "label": "Several times per month"}, {"key": "rarely", "label": "Rarely"}, {"key": "never", "label": "Never"}]}, {"key": "s13", "type": "single", "label": "How does one flight of stairs usually feel?", "questionKey": "s13", "question": "How does one flight of stairs usually feel?", "options": [{"key": "o1", "label": "I feel short of breath"}, {"key": "o2", "label": "I feel slightly winded, but I'm okay"}, {"key": "o3", "label": "I feel fine after one flight of stairs"}, {"key": "o4", "label": "I can easily climb 3-5 flights of stairs"}]}, {"key": "s14", "type": "single", "label": "How often do you go for walks?", "questionKey": "s14", "question": "How often do you go for walks?", "options": [{"key": "o1", "label": "Almost every day"}, {"key": "o2", "label": "2-3 times per week"}, {"key": "o3", "label": "More like once a month"}, {"key": "rarely", "label": "Rarely"}, {"key": "never", "label": "Never"}]}, {"key": "s15", "type": "information", "label": "Set a pace that fits"}, {"key": "s16", "type": "single", "label": "What's your workday?", "questionKey": "s16", "question": "What's your workday?", "options": [{"key": "o1", "label": "9 to 5"}, {"key": "o2", "label": "Night shifts"}, {"key": "o3", "label": "It's fairly flexible"}, {"key": "o4", "label": "I'm retired"}]}, {"key": "s17", "type": "single", "label": "How much movement does a usual day involve?", "questionKey": "s17", "question": "How much movement does a usual day involve?", "options": [{"key": "o1", "label": "I'm on my feet all day long"}, {"key": "o2", "label": "I take active breaks"}, {"key": "o3", "label": "I spend most of the day sitting"}]}, {"key": "s18", "type": "information", "label": "Make time to move"}, {"key": "s19", "type": "number", "label": "How tall are you?", "questionKey": "s19", "question": "How tall are you?"}, {"key": "s20", "type": "number", "label": "What's your current weight?", "questionKey": "s20", "question": "What's your current weight?"}, {"key": "s21", "type": "number", "label": "What weight would you like to work toward?", "questionKey": "s21", "question": "What weight would you like to work toward?"}, {"key": "s22", "type": "number", "label": "How old are you?", "questionKey": "s22", "question": "How old are you?"}, {"key": "s23", "type": "text", "label": "What's your name?", "questionKey": "s23", "question": "What's your name?"}, {"key": "s24", "type": "single", "label": "Do you have a particular occasion in mind?", "questionKey": "s24", "question": "Do you have a particular occasion in mind?", "options": [{"key": "o1", "label": "Vacation"}, {"key": "o2", "label": "Sporting event"}, {"key": "o3", "label": "Beach trip"}, {"key": "o4", "label": "Wedding"}, {"key": "o5", "label": "Family occasion"}, {"key": "o6", "label": "Reunion"}, {"key": "o7", "label": "No similar events"}]}, {"key": "s25", "type": "text", "label": "When's the event?", "questionKey": "s25", "question": "When's the event?"}, {"key": "s26", "type": "text", "label": "Where can we email you?", "questionKey": "s26", "question": "Where can we email you?"}, {"key": "s27", "type": "information", "label": "Your Mat Pilates starting point is ready"}, {"key": "s28", "type": "result", "label": "Flo Pilates: 28-Day Sculpt and Tone Mat-Pilates Program"}], "numberUnits": {"s19": "cm", "s20": "kg", "s21": "kg", "s22": "years"}};
const restoredJourney=await restoreAnnualJourney({app,flow,definition,config:annualResumeConfig,sdk:window.NyQuiz,restoreFields:false});
const pgAnalytics=createPgQuizBridge({app,flow,definition,config:annualResumeConfig});


let panels=[...app.querySelectorAll('[data-flow-screen]')];
let editorPanel=null;
let selectedPlan=0;
const plans=[{label:'Flo subscription',price:'14.99',renew:'39.00',renewal:'39.00',period:'28 days',term:'28 days',discount:0}];
const panel=()=>panels.find(x=>x.dataset.flowScreen===(editorPanel||flow.current.id));
const unit=p=>p.querySelector('[data-flow-unit]:checked')?.dataset.flowUnit||'imperial';
const inputs=p=>[...p.querySelectorAll('[data-flow-input]')];
function error(message){let p=panel();let el=p.querySelector('[data-flow-error]');if(!el){el=document.createElement('p');el.dataset.flowError='';el.setAttribute('role','alert');el.className='pg-flow-error';(p.querySelector('form')||p).append(el);}el.textContent=message;el.hidden=!message;}
function inputValue(p){
 const id=p.dataset.flowScreen;
 if(id==='s03')return [...p.querySelectorAll('[data-flow-option]:checked')].map(x=>x.value);
 if(p.querySelector('[data-flow-option]'))return p.querySelector('[data-flow-option]:checked')?.value;
 const fields=inputs(p), values=fields.map(x=>x.value.trim());
 if(id==='s19')return values[0]?unit(p)==='metric'?Number(values[0]):(Number(values[0])*12+Number(values[1]||0))*2.54:undefined;
 if(['s20','s21'].includes(id))return values[0]?Number(values[0])*(unit(p)==='metric'?1:0.45359237):undefined;
 if(id==='s22')return values[0]?Number(values[0]):undefined;
 return fields.length?values[0]:undefined;
}
function requiresLowerTarget(answers){
 const goals=answers.s03;
 return !Array.isArray(goals)||goals.length===0||goals.includes('o1');
}
function offerOptionLabel(screenId,value){
 if(typeof value!=='string')return '';
 const p=panels.find(x=>x.dataset.flowScreen===screenId);
 const input=[...(p?.querySelectorAll('[data-flow-option]')||[])].find(x=>x.dataset.flowOption===value);
 return input?.closest('label')?.querySelector('.checkbox-wrapper__title')?.textContent.trim()||input?.getAttribute('title')||'';
}
function updateOfferShapes(offer){
 const imgs=offer.querySelectorAll('.lf-ba__img');
 for(const [index,screen] of ['s05','s06'].entries()){
  const source=[...app.querySelectorAll('[data-flow-screen="'+screen+'"] [data-flow-option]')].find(x=>x.dataset.flowOption===flow.answers[screen])?.closest('label')?.querySelector('img');
  if(imgs[index]&&source){imgs[index].src=source.currentSrc||source.src;imgs[index].removeAttribute('srcset');imgs[index].alt=offerOptionLabel(screen,flow.answers[screen]);imgs[index].style.objectFit='contain';}
 }

 const columns=offer.querySelectorAll('.lf-ba__info .lf-ba__col');
 const current=columns[0]?.querySelector('.lf-ba__val'),goal=columns[1]?.querySelector('.lf-ba__val');
 if(current)current.textContent=offerOptionLabel('s05',flow.answers.s05)||'Not selected';
 if(goal)goal.textContent=offerOptionLabel('s06',flow.answers.s06)||'Not selected';
}
function syncEventDateCopy(){
 const p=panels.find(x=>x.dataset.flowScreen==='s25');if(!p)return;
 const heading=p.querySelector('.calendarReel-wrapper__title'),input=p.querySelector('[data-flow-input]');
 const noEvent=flow.answers.s24==='o7';
 if(heading){
  if(heading.dataset.pgEventHeading===undefined)heading.dataset.pgEventHeading=heading.textContent;
  heading.textContent=noEvent?'Any date in mind?':heading.dataset.pgEventHeading;
 }
 if(input){
  if(input.dataset.pgEventLabel===undefined)input.dataset.pgEventLabel=input.getAttribute('aria-label')||'Event date';
  input.setAttribute('aria-label',noEvent?'Optional target date':input.dataset.pgEventLabel);
 }
}
function updateOffer(){
 const offer=panels.at(-1),a=flow.answers,plan=plans[selectedPlan];
 updateOfferShapes(offer);
 const name=offer.querySelector('[data-result-name]');if(name&&a.s23)name.textContent=a.s23+', choose your Flo Pilates plan!';
 const targets=offer.querySelectorAll('[class*="targets_caption"]');
 if(targets[0]&&a.s21){const span=targets[0].querySelector('span');if(span)span.textContent=Math.round(a.s21/(unit(panels.find(x=>x.dataset.flowScreen==='s21'))==='metric'?1:0.45359237))+(unit(panels.find(x=>x.dataset.flowScreen==='s21'))==='metric'?' kg':' lbs');}
 if(targets[1]&&a.s17){const span=targets[1].querySelector('span');if(span)span.textContent=({o1:'High',o2:'Medium',o3:'Low'})[a.s17];}
 const goal=offer.querySelector('[data-result-goal]');if(goal&&a.s03?.length)goal.textContent=a.s03.map(v=>panels.find(x=>x.dataset.flowScreen==='s03').querySelector('[data-flow-option="'+v+'"]')?.closest('label')?.textContent.trim()).filter(Boolean).join(', ');
 const fitness=offer.querySelector('[data-result-fitness]');if(fitness&&a.s08)fitness.textContent=({o1:'Experienced',o2:'Some experience',o3:'Beginner'})[a.s08];
 const bmi=a.s19&&a.s20?a.s20/Math.pow(a.s19/100,2):null;
 if(bmi){const header=offer.querySelector('[class*="bmiHeaderValue"]');if(header)header.textContent=bmi.toFixed(1);const position=bmi<18.5?Math.max(8,16.667-(18.5-bmi)*3):bmi<25?16.667+(bmi-18.5)/6.5*33.333:bmi<30?50+(bmi-25)/5*33.333:Math.min(92,83.333+(bmi-30)*1.5);const indicator=offer.querySelector('[class*="bmiIndicator"]');if(indicator){indicator.style.insetInlineStart=position+'%';indicator.style.transform='translateX(-50%)';}const color=bmi<18.5?'#32bc6f':bmi<25?'#d4c65f':bmi<30?'#febb83':'#ff5755';offer.querySelectorAll('[class*="bmiCircle"]').forEach(x=>{if(x.className.includes('Dot'))x.style.background=color;else x.style.borderColor=color;});const categoryColor=offer.querySelector('[data-result-bmi-category]');if(categoryColor)categoryColor.style.color=color;const tooltip=offer.querySelector('[data-result-bmi]');if(tooltip)tooltip.textContent='Your '+bmi.toFixed(1);const category=offer.querySelector('[data-result-bmi-category]');if(category)category.textContent=bmi<18.5?'Underweight':bmi<25?'Normal':bmi<30?'Overweight':'Obese';const box=offer.querySelector('[data-bmi-explanation]');if(box)box.textContent='Your height and weight give a BMI of '+bmi.toFixed(1)+'. This screening number does not describe body composition or give a complete picture of health.';offer.querySelectorAll('[class*="bmi"]').forEach(x=>{if(x.children.length===0&&x.textContent.trim()==='Your 28.3')x.textContent='Your '+bmi.toFixed(1);});}
 offer.querySelectorAll('[data-offer-plan]').forEach((button,i)=>{button.setAttribute('aria-pressed',String(i===selectedPlan));button.classList.toggle('pg-plan-selected',i===selectedPlan);button.dataset.selected=String(i===selectedPlan);for(const c of [...button.classList])if(c.endsWith('__card--selected'))button.classList.remove(c);const radio=button.querySelector('[class*="card__radio"]');if(radio)radio.dataset.selected=String(i===selectedPlan);});
 const billing=offer.querySelector('[data-billing-summary]');if(billing)billing.textContent="Pay $14.99 USD today for your first 28 days of your Flo subscription. Renews automatically at $39 USD every 28 days until canceled. No free trial. Review the subscription terms at checkout.";
}
function updateCurrentBmi(){
 const p=panels.find(x=>x.dataset.flowScreen==='s20'),box=p.querySelector('[data-current-bmi]');if(!box)return;
 const weight=inputValue(p),height=flow.answers.s19;box.hidden=!(Number.isFinite(weight)&&weight>=25&&weight<=450&&height>=100&&height<=250);if(box.hidden)return;
 const bmi=weight/(height/100)**2,category=bmi<18.5?'underweight':bmi<25?'normal weight':bmi<30?'overweight':'obese';
 const text=box.querySelector('.explanation-wrapper__header');text.dataset.template ||= text.textContent;text.textContent=text.dataset.template.replace('[bmi]',bmi.toFixed(1)).replace('[category]',category);
 box.style.backgroundColor=bmi<18.5?'#ffdf9e':bmi<25?'#d9efdf':bmi<30?'#ffa500':'#ffc3bd';
}
function updateTargetWarning(){
 const p=panels.find(x=>x.dataset.flowScreen==='s21');if(!p)return;
 const box=p.querySelector('.explanation-out-of-bmi-range'),progress=p.querySelector('[data-target-progress]');
 const v=inputValue(p),height=flow.answers.s19,current=flow.answers.s20;
 const valid=Number.isFinite(v)&&v>=25&&v<=450&&Number.isFinite(height)&&height>=100&&height<=250;
 const bmi=valid?v/(height/100)**2:null,outside=valid&&(bmi<18.5||bmi>24.9);
 if(box){
  box.hidden=!outside;
  if(outside){
   const min=18.5*(height/100)**2,max=24.9*(height/100)**2,metric=unit(p)==='metric',values=box.querySelectorAll('strong');
   if(values[1])values[1].textContent=Math.round(min/(metric?1:.45359237))+(metric?' kg':' lbs');
   if(values[2])values[2].textContent=Math.round(max/(metric?1:.45359237))+(metric?' kg':' lbs');
  }
 }
 if(progress){
  progress.hidden=!(valid&&!outside&&Number.isFinite(current)&&current>=25&&current<=450&&v<current);
  if(!progress.hidden){
   const heading=progress.querySelector('[data-target-progress-heading]');
   if(heading)heading.textContent=heading.dataset.template.replace('[percent]',String(Math.round((current-v)/current*100)));
  }
 }
}
function syncGoalButton(p=panel()){
 if(p?.dataset.flowScreen!=='s03')return;
 const disabled=!p.querySelector('input[data-flow-option]:checked');
 p.querySelectorAll('[data-flow-next]').forEach(button=>{button.disabled=disabled;});
}
function toggleLanguageControl(lang){
 const menu=lang.querySelector('[data-language-menu]');if(!menu)return;
 menu.hidden=!menu.hidden;
 lang.setAttribute('aria-expanded',String(!menu.hidden));
}
function show(id=flow.current.id){panels.forEach(x=>{x.hidden=x.dataset.flowScreen!==id;});app.dataset.currentScreen=id;pgAnalytics.show(id);document.body.classList.toggle('pg-at-offer',id==='s28');if(id==='s28')updateOffer();fm17Offer(panels.find(x=>x.dataset.flowScreen===id),id);fm17PlanReady(id);if(id==='s20')updateCurrentBmi();if(id==='s21')updateTargetWarning();if(id==='s03')syncGoalButton(panels.find(x=>x.dataset.flowScreen===id));if(id==='s25')syncEventDateCopy();window.scrollTo({top:0,behavior:'instant'});const heading=panel()?.querySelector('h1,h2,[class*="landing-title"]');if(heading){heading.tabIndex=-1;if(id!=='s01')heading.focus({preventScroll:true});}}
function advance(explicit){
 const p=panel(),id=p.dataset.flowScreen,v=explicit===undefined?inputValue(p):explicit;if(id==='s25'){const dateError=quizEventDateError(v);if(dateError){error(dateError);return;}}
 if(id==='s01'&&p.querySelector('input[type="checkbox"]')&&!p.querySelector('input[type="checkbox"]').checked){error('Select the checkbox before continuing.');return;}
 if(id==='s26'&&!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v||'')){error('Enter a valid email address.');return;}
 if(id==='s23'&&String(v||'').length<2){error('Enter at least two characters.');return;}
 if(id==='s19'&&(!v||v<100||v>250)){error(unit(p)==='metric'?'Enter a height between 100 and 250 cm.':'Enter a height between about 3 ft 3 in and 8 ft 2 in.');return;}
 if(['s20','s21'].includes(id)&&(!v||v<25||v>450)){error(unit(p)==='metric'?'Enter a weight between 25 and 450 kg.':'Enter a weight between about 55 and 992 lbs.');return;}
 if(id==='s21'&&requiresLowerTarget(flow.answers)&&flow.answers.s20&&v>=flow.answers.s20){error('Your target weight should be lower than your current one');p.querySelectorAll('[data-flow-next],button[type="submit"]').forEach(x=>x.disabled=true);return;}
 error('');
 if(editorPanel){const next=definition.screens.find(s=>s.id===editorPanel)?.next;if(next){editorPanel=next;show(next);}return;}
 const result=flow.next(v);if(!result.ok){error(result.error==='required'?'Choose an answer before continuing.':'Check your answer and try again.');return;}document.addEventListener('mouseleave',event=>{if(event.clientY<=0&&flow.current.id==='s28'){const modal=panel().querySelector('[data-exit-dialog]');if(modal&&!modal.dataset.seen){modal.hidden=false;modal.dataset.seen='true';}}});
show();
}
// Native radio clicks also fire when an already selected answer is revisited.
// Resolve the active panel so Shopify editor navigation uses the same rule.
function advanceRadioOption(target){
 if(!target.matches('input[type="radio"][data-flow-option]')||!target.checked||target.disabled)return false;
 const active=panel();
 if(target.closest('[data-flow-screen]')!==active)return false;
 const screen=definition.screens.find(s=>s.id===active.dataset.flowScreen);
 if(!screen?.autoAdvance||screen.input?.type!=='single')return false;
 advance(target.value);
 return true;
}
app.addEventListener('submit',event=>{event.preventDefault();advance();});
app.addEventListener('click',event=>{
 const target=event.target;
 if(target.closest('[data-clear-email]')){const field=panel().querySelector('[data-flow-input]');field.value='';error('');field.focus();return;}
 if(advanceRadioOption(target))return;
 const lang=target.closest('[data-language-toggle]');if(lang){toggleLanguageControl(lang);return;}
 if(target.closest('[data-flow-back]')){event.preventDefault();if(editorPanel){const index=panels.indexOf(panel());editorPanel=panels[Math.max(0,index-1)].dataset.flowScreen;show(editorPanel);}else if(flow.back())show();return;}
 const choice=target.closest('[data-flow-choice]');if(choice){advance(choice.dataset.flowChoice);return;}
 if(target.closest('[data-flow-skip]')){event.preventDefault();advance('');return;}
 if(target.closest('[data-flow-next]')&&(!target.closest('button[type="submit"]')||!target.closest('button').form)){event.preventDefault();advance();return;}
 const consent=target.closest('[data-offer-consent]');if(consent&&consent.getAttribute('role')==='checkbox'){consent.setAttribute('aria-checked',String(consent.getAttribute('aria-checked')!=='true'));return;}
 const plan=target.closest('[data-offer-plan]');if(plan){selectedPlan=Number(plan.dataset.offerPlan);updateOffer();return;}
 if(target.closest('[data-offer-choose]')){event.preventDefault();const selected=panel().querySelector('[data-offer-plan][aria-pressed="true"]');selected?.scrollIntoView({behavior:'smooth',block:'center'});selected?.focus();return;}
 const dismiss=target.closest('[data-offer-dismiss]');if(dismiss){const modal=dismiss.closest('[data-exit-dialog]');if(modal)modal.hidden=true;}
});
app.addEventListener('keydown',event=>{if(['Enter',' '].includes(event.key)){const lang=event.target.closest('[data-language-toggle]');if(lang){event.preventDefault();toggleLanguageControl(lang);return;}}if(['Enter',' '].includes(event.key)&&event.target.matches('[data-offer-plan]')){event.preventDefault();selectedPlan=Number(event.target.dataset.offerPlan);updateOffer();return;}if(['Enter',' '].includes(event.key)&&event.target.matches('[data-flow-choice]')){event.preventDefault();advance(event.target.dataset.flowChoice);}});
app.addEventListener('change',event=>{
 const target=event.target,p=panel();
 if(target.matches('[data-flow-option]')){
  // A new radio emits change after click; the click may already show the next panel.
  if(target.closest('[data-flow-screen]')!==p)return;
  error('');advanceRadioOption(target);p.querySelectorAll('button[disabled]').forEach(x=>x.disabled=false);syncGoalButton(p);
 }
 if(target.matches('[data-flow-unit]')){
   error('');
   const metric=target.dataset.flowUnit==='metric';const id=p.dataset.flowScreen,fields=inputs(p),labels=p.querySelectorAll('.input-description');
   if(id==='s19'){if(labels[0])labels[0].textContent=metric?'cm':'ft';const inches=p.querySelector('.height-heightInches');if(inches)inches.hidden=metric;fields[0]?.setAttribute('aria-label',metric?'Height in centimeters':'Feet');}
   else if(labels[0])labels[0].textContent=metric?'kg':'lbs';
   fields.forEach(x=>x.value='');if(id==='s20')updateCurrentBmi();if(id==='s21')updateTargetWarning();
 }
});
app.addEventListener('input',()=>{if(panel().dataset.flowScreen==='s20')updateCurrentBmi();if(panel().dataset.flowScreen==='s21')updateTargetWarning();panel().querySelectorAll('button[disabled]').forEach(x=>x.disabled=false);error('');syncGoalButton();});
document.addEventListener('shopify:section:load',event=>{panels=[...app.querySelectorAll('[data-flow-screen]')];const replacement=event.target.querySelector('[data-flow-screen]');if(replacement){if(!panels.some(x=>x.dataset.flowScreen===editorPanel))editorPanel=replacement.dataset.flowScreen;show(editorPanel||replacement.dataset.flowScreen);}});
document.addEventListener('shopify:block:select',event=>{const p=event.target.closest('[data-flow-screen]');if(p){editorPanel=p.dataset.flowScreen;show(editorPanel);}});
document.addEventListener('shopify:section:select',event=>{const p=event.target.querySelector('[data-flow-screen]');if(p){editorPanel=p.dataset.flowScreen;show(editorPanel);}});
document.addEventListener('mouseleave',event=>{if(event.clientY<=0&&flow.current.id==='s28'){const modal=panel().querySelector('[data-exit-dialog]');if(modal&&!modal.dataset.seen){modal.hidden=false;modal.dataset.seen='true';}}});
restoreQuizJourneyFields({app,saved:restoredJourney});
setupFm17Headers();
show();


/* Analytics only. Bundle the collector in this same hashed module BEFORE the
 * renderer, so the first event enters its durable queue without another fetch.
 * No copy, routing, input, image, payment or DOM mutations. */
function createPgQuizBridge({app,flow,definition,config},env=window){
 const noop={show(){},cta(){}};
 try{
  if(env.Shopify?.designMode||!app||app.__pgQuizBridge)return app?.__pgQuizBridge||noop;
  const sdk=env.NyQuiz;
  if(!sdk?.init||!sdk?.trackOnce)throw Error('Bundled quiz collector is missing');
  const screens=new Map(config.screens.map(s=>[s.key,s]));
  let lastScreen=null;
  const initialized=Promise.resolve(sdk.init({quizKey:config.quizKey,versionKey:config.versionKey,
   endpoint:config.endpoint||'https://growth.nysonik.com',landingUrl:config.sourceUrl})).catch(()=>{});
  // These are the existing, source-locked contact fields only. Other free text
  // (dates, country, etc.) remains outside both analytics and identity capture.
  const contactFields={
   'pg-justfit':{email:'s36',name:'s37'},
   'pg-lasta':{email:'s26',name:'s23'},
   'pg-yoga-go':{email:'s31'}
  }[config.quizKey];
  let identityPending=null,identitySaved='',identityAttemptKey='',identityAttempts=0;
  function identify(){
   if(!contactFields||env.Shopify?.designMode||typeof sdk.identify!=='function')return Promise.resolve(false);
   if(identityPending)return identityPending;
   const values=flow.answers||{},email=values[contactFields.email];
   // Wait for a usable contact key so name-first flows do not create orphan
   // name-only identities. Always send the full current contact together.
   if(typeof email!=='string'||email.length>254||!/^\S+@\S+\.\S+$/.test(email.trim()))return Promise.resolve(false);
   const name=values[contactFields.name],data={email:email.trim()};
   if(typeof name==='string'&&name.trim())data.firstName=name.trim().slice(0,120);
   const key=JSON.stringify(data);
   if(key===identitySaved)return Promise.resolve(true);
   if(key!==identityAttemptKey){identityAttemptKey=key;identityAttempts=0;}
   if(identityAttempts>=3)return Promise.resolve(false);
   identityAttempts++;
   identityPending=initialized.then(async()=>{if(identityAttempts>1)await new Promise(resolve=>env.setTimeout(resolve,identityAttempts===2?500:2000));return sdk.identify(data);}).then(ok=>{if(ok===true)identitySaved=key;return ok===true;}).catch(()=>false).finally(()=>{identityPending=null;});
   // Drain changed fields submitted while the previous request was running,
   // and retry transient failures at most three times for this exact contact.
   identityPending.then(()=>identify());
   return identityPending;
  }
  function send(type,data,once=false){try{return once?sdk.trackOnce(type,data):sdk.track(type,data);}catch{return null;}}
  function panel(id){return app.querySelector('[data-flow-screen="'+id+'"]');}
  function show(id){try{
   if(env.Shopify?.designMode||!screens.has(id)||lastScreen===id)return;
   identify();
   send('quiz_start',{screenKey:id},true);
   const previous=lastScreen;lastScreen=id;
   send('screen_view',{screenKey:id,properties:previous?{previousScreenKey:previous}:{}});
   if(config.resultScreens.includes(id))send('result_view',{screenKey:id,resultKey:id});
   if(config.completeScreens.includes(id))send('quiz_complete',{screenKey:id},true);
  }catch{}}
  function answer(id,value){
   const s=screens.get(id);
   if(!s?.questionKey||s.type==='text')return; // Exclude names, emails, dates, country and arbitrary text.
   if(value===undefined||value===null||value===''||(Array.isArray(value)&&!value.length)){
    send('answer',{screenKey:id,questionKey:s.questionKey,answerValue:null,answerLabel:'Skipped'});return;
   }
   if(s.options){
    const values=Array.isArray(value)?value:[value],map=new Map(s.options.map(o=>[o.key,o.label]));
    if(values.some(v=>!map.has(v)))return;
    send('answer',{screenKey:id,questionKey:s.questionKey,answerValue:value,answerLabel:values.map(v=>map.get(v)).join('; ')});
   }else if(s.type==='number'&&typeof value==='number'&&Number.isFinite(value)){
    const unit=config.numberUnits?.[id];
    send('answer',{screenKey:id,questionKey:s.questionKey,answerValue:value,
     answerLabel:String(Math.round(value*100)/100)+(unit?' '+unit:''),
     properties:unit?{unit}: {}});
   }
  }
  const originalNext=flow.next.bind(flow),originalBack=flow.back.bind(flow);
  flow.next=function(value){const id=flow.current.id;const result=originalNext(value);if(result.ok&&!env.Shopify?.designMode){try{answer(id,value);identify();}catch{}}return result;};
  flow.back=function(){const id=flow.current.id;const result=originalBack();if(result&&!env.Shopify?.designMode)send('back',{screenKey:id});return result;};
  function cta(action,clickedPlan){try{
   if(env.Shopify?.designMode||!lastScreen||!config.completeScreens.includes(lastScreen))return;
   if(!['offer_summary','scroll_to_plans','plan_select'].includes(action))return;
   const p=panel(lastScreen),card=clickedPlan||p?.querySelector('[data-offer-plan][aria-pressed="true"]');
   const raw=card?.getAttribute('data-offer-plan'),properties={action};
   if(/^[0-9]{1,2}$/.test(raw||''))properties.planIndex=Number(raw);
   // Only public plan-card copy, never other panel text or personal inputs.
   const label=card?.textContent?.replace(/\s+/g,' ').trim().slice(0,500);
   if(label)properties.planLabel=label;
   send(action==='offer_summary'?'cta_click':'offer_interaction',{screenKey:lastScreen,properties});
   Promise.resolve(sdk.flush()).catch(()=>{});
  }catch{}}
  const bridge={show,cta,identify};app.__pgQuizBridge=bridge;
  app.addEventListener('click',event=>{try{
   const t=event.target;if(!t?.closest)return;
   const plan=t.closest('[data-offer-plan]');
   if(plan)cta('plan_select',plan);
   else if(t.closest('[data-offer-checkout]'))cta('offer_summary');
   else if(t.closest('[data-offer-choose],[data-offer-scroll]'))cta('scroll_to_plans');
  }catch{}});
  return bridge;
 }catch(error){
  try{env.dispatchEvent(new env.CustomEvent('nyquiz:health',{detail:{status:'blocked',reason:'pg_bridge_initialization_failed'}}));}catch{}
  return noop;
 }
}


/* Shared subscription handoff. No contact details or quiz answers leave
 * Quiz Lab. Only the visit, quiz and immutable version identify the purchase. */
const ANNUAL_OFFER = Object.freeze({
  endpoint: 'https://a56ba5-6f.myshopify.com/api/2026-10/graphql.json',
  variantId: 'gid://shopify/ProductVariant/67709186343157',
  sellingPlanId: 'gid://shopify/SellingPlan/10461085941',
  amount: 14.99,
  currency: 'USD',
});

const ANNUAL_CART_MUTATION = `mutation QuizAnnualCart($input: CartInput!) {
  cartCreate(input: $input) {
    cart {
      checkoutUrl attributes { key value }
      cost { totalAmount { amount currencyCode } }
      lines(first: 2) { nodes {
        quantity merchandise { ... on ProductVariant { id } }
        sellingPlanAllocation { sellingPlan { id name } }
      } }
    }
    userErrors { field message code }
  }
}`;

function annualCartInput({sessionId, quizKey, versionKey}) {
  if (!/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(sessionId || '')) {
    throw new Error('Your quiz visit could not be saved. Please try again.');
  }
  if (!['pg-betterme-men', 'pg-justfit', 'pg-lasta', 'pg-yoga-go'].includes(quizKey)
    || !/^pg-[0-9a-f]{16}$/.test(versionKey || '')) {
    throw new Error('This quiz offer is not configured.');
  }
  return {
    lines: [{quantity: 1, merchandiseId: ANNUAL_OFFER.variantId, sellingPlanId: ANNUAL_OFFER.sellingPlanId}],
    attributes: [
      {key: '__nyq_session', value: sessionId},
      {key: '__nyq_quiz', value: quizKey},
      {key: '__nyq_version', value: versionKey},
    ],
  };
}

function verifiedAnnualCheckout(response, input) {
  const result = response?.data?.cartCreate;
  if (response?.errors?.length || result?.userErrors?.length || !result?.cart) {
    throw new Error('Checkout is unavailable. Please try again.');
  }
  const cart = result.cart, lines = cart.lines?.nodes || [];
  if (lines.length !== 1 || lines[0].quantity !== 1
    || lines[0].merchandise?.id !== ANNUAL_OFFER.variantId
    || lines[0].sellingPlanAllocation?.sellingPlan?.id !== ANNUAL_OFFER.sellingPlanId
    || Number(cart.cost?.totalAmount?.amount) !== ANNUAL_OFFER.amount
    || cart.cost?.totalAmount?.currencyCode !== ANNUAL_OFFER.currency) {
    throw new Error('The checkout price or subscription has changed. Please try again later.');
  }
  const attributes = new Map((cart.attributes || []).map(a => [a.key, a.value]));
  if (input.attributes.some(a => attributes.get(a.key) !== a.value)) {
    throw new Error('Your quiz could not be linked to checkout. Please try again.');
  }
  let url;
  try { url = new URL(cart.checkoutUrl); } catch { throw new Error('Checkout is unavailable. Please try again.'); }
  if (url.protocol !== 'https:' || url.hostname !== 'pilatesflo.com'
    || url.username || url.password || url.port
    || !(/^\/cart\/c\//.test(url.pathname) || /^\/checkouts\//.test(url.pathname))) {
    throw new Error('Checkout is unavailable. Please try again.');
  }
  return url.href;
}

function createAnnualCheckout({sdk, quizKey, versionKey, fetchImpl = fetch, navigate = url => window.location.assign(pgTrybeCheckoutUrl(url, window.location.search))}) {
  let pending = null;
  let prepared = null;
  async function saveEvents() {
    const deadline = Date.now() + 8000;
    do {
      let timer;
      try {
        await Promise.race([
          sdk.flush(),
          new Promise((_, reject) => { timer = setTimeout(() => reject(new Error('Your quiz could not be saved. Please try again.')), Math.max(1, deadline - Date.now())); }),
        ]);
      } finally { clearTimeout(timer); }
      const health = sdk.getHealth?.();
      if (!health || (health.status !== 'blocked' && health.pending === 0)) return;
      if (health.status === 'blocked') break;
      await new Promise(resolve => setTimeout(resolve, 100));
    } while (Date.now() < deadline);
    throw new Error('Your quiz could not be saved. Please try again.');
  }
  return function checkout(screenKey) {
    if (pending) return pending;
    pending = (async () => {
      // Bootstrap/flush first so a new or resumed visit has its real identifier.
      await saveEvents();
      const input = annualCartInput({sessionId: sdk.getSessionId(), quizKey, versionKey});
      const identity = JSON.stringify(input.attributes);
      if (prepared?.identity === identity) {
        await saveEvents();
        navigate(prepared.url);
        return true;
      }
      const response = await fetchImpl(ANNUAL_OFFER.endpoint, {
        method: 'POST', credentials: 'omit',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({query: ANNUAL_CART_MUTATION, variables: {input}}),
        signal: AbortSignal.timeout(15000),
      });
      // Never automatically retry a cart creation whose response was lost.
      if (!response.ok) throw new Error('Checkout is unavailable. Please try again.');
      const url = verifiedAnnualCheckout(await response.json(), input);
      prepared = {identity, url};
      sdk.track('cta_click', {screenKey, properties: {
        action: 'checkout_started', planLabel: 'Flo subscription',
        amount: 14.99, currency: 'USD', billingPeriod: '28_days',
      }});
      await saveEvents();
      navigate(url);
      return true;
    })().finally(() => { pending = null; });
    return pending;
  };
}

/* Binds the real annual cart to the existing offer controls. */
function bindAnnualCheckout({app, sdk, quizKey, versionKey, checkoutFactory, saveJourney = () => {}, designMode = false}) {
  if (designMode || app.__annualCheckoutBound) return;
  app.__annualCheckoutBound = true;
  const checkout = checkoutFactory({sdk, quizKey, versionKey});
  let busy = false;
  app.addEventListener('click', async event => {
    const target = event.target?.closest?.('[data-annual-checkout]');
    if (!target || !app.contains(target)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy) return;
    const panel = target.closest('[data-flow-screen]');
    if (!panel || panel.hidden) return;
    let status = panel.querySelector('[data-annual-checkout-status]');
    if (!status) {
      status = document.createElement('p');
      status.dataset.annualCheckoutStatus = '';
      status.setAttribute('role', 'status');
      status.style.cssText = 'font:inherit;padding:12px;text-align:center;';
      target.insertAdjacentElement('afterend', status);
    }
    const consent = panel.querySelector('[data-offer-consent]');
    if (consent && consent.getAttribute('aria-checked') !== 'true') {
      status.textContent = 'Review the terms and select the agreement checkbox to continue.';
      consent.scrollIntoView({block: 'center', behavior: 'smooth'});
      consent.focus();
      return;
    }
    busy = true;
    const controls = [...app.querySelectorAll('[data-annual-checkout]')];
    controls.forEach(button => { button.disabled = true; button.setAttribute('aria-busy', 'true'); });
    status.textContent = 'Opening your $14.99 first 28-day Flo subscription checkout…';
    try {
      saveJourney(panel.dataset.flowScreen);
      await checkout(panel.dataset.flowScreen);
    } catch (error) {
      status.textContent = error instanceof Error ? error.message : 'Checkout is unavailable. Please try again.';
    } finally {
      busy = false;
      controls.forEach(button => { button.disabled = false; button.removeAttribute('aria-busy'); });
    }
  }, true);
}

/* Same-tab progress and checkout return. No answer or contact data leaves the browser. */
// These helpers are hoisted: compiled renderers restore before this source's
// position in the bundle is evaluated.
function journeyFields(schema = 3) {
  const legacy = 'input,select,textarea,[data-flow-unit],[data-offer-consent]';
  const selections = 'input,select,textarea,[data-flow-option],[data-flow-choice],[data-flow-unit],[data-offer-consent],[data-multi-footer]';
  return schema < 2 ? legacy : schema === 2 ? selections : selections + ',[data-flow-next]';
}
function journeyDecorations(app) {
  return [...app.querySelectorAll('[data-flow-screen]')].flatMap(panel => {
    const labels = [...panel.querySelectorAll('[data-unit-label],[data-range-min],[data-range-max],[data-date-value],.input-description,[class*="postfix"]')];
    const hidden = [...panel.querySelectorAll('[data-inches-wrap],.height-heightInches,[data-body-zone]')];
    const units = [...panel.querySelectorAll('[data-flow-unit]')];
    const fields = [...panel.querySelectorAll('[data-flow-input]')];
    // Calisthenics uses an unmarked wrapper for the inches input; Fitness uses
    // a decorative pill behind its unit buttons. Only these unit controls apply.
    if (units.length && fields.length > 1 && fields[1].parentElement) hidden.push(fields[1].parentElement);
    for (const unit of units) {
      const indicator = unit.parentElement?.querySelector('.absolute');
      if (indicator) hidden.push(indicator);
    }
    return [{panel, labels, hidden:[...new Set(hidden)]}];
  });
}
function restoreQuizJourneyFields({app, saved}) {
  if (!saved) return;
  const fields = [...app.querySelectorAll(journeyFields(saved.schema || 1))];
  for (const item of saved.fields || []) {
    const field = fields[item.index]; if (!field) continue;
    if (typeof item.value === 'string' && 'value' in field) field.value = item.value;
    if (typeof item.checked === 'boolean' && 'checked' in field) field.checked = item.checked;
    if (item.ariaChecked === 'true' || item.ariaChecked === 'false') field.setAttribute('aria-checked', item.ariaChecked);
    if (item.ariaSelected === 'true' || item.ariaSelected === 'false') field.setAttribute('aria-selected', item.ariaSelected);
    if (item.pressed === 'true' || item.pressed === 'false') field.setAttribute('aria-pressed', item.pressed);
    if (typeof item.hidden === 'boolean' && field.matches?.('[data-multi-footer]')) field.hidden = item.hidden;
    if (typeof item.disabled === 'boolean' && field.matches?.('[data-flow-next]')) field.disabled = item.disabled;
    for (const attribute of ['placeholder','maxlength','aria-label']) {
      if (typeof item.attributes?.[attribute] === 'string') field.setAttribute(attribute, item.attributes[attribute]);
      else if (item.attributes?.[attribute] === null) field.removeAttribute(attribute);
    }
  }
  const panels = [...app.querySelectorAll('[data-flow-screen]')];
  for (const item of saved.units || []) {
    const panel = panels.find(p => p.dataset.flowScreen === item.screen);
    if (panel && ['metric','imperial'].includes(item.unit)) panel.dataset.unit = item.unit;
  }
  for (const {panel,labels,hidden} of journeyDecorations(app)) {
    const state = saved.decorations?.find(item => item.screen === panel.dataset.flowScreen);
    if (!state) continue;
    for (const [index, item] of (state.labels || []).entries()) {
      const label = labels[index]; if (!label) continue;
      if (typeof item.text === 'string') label.textContent = item.text;
      if (typeof item.original === 'string') label.dataset.original = item.original;
    }
    for (const [index, value] of (state.hidden || []).entries()) if (hidden[index] && typeof value === 'boolean') hidden[index].hidden = value;
  }
}
function replayAnnualJourney(flow, definition, saved) {
  if (!saved || !Array.isArray(saved.visited) || saved.visited.length > definition.screens.length || saved.visited[0] !== definition.start) return false;
  const trial = new flow.constructor(definition);
  for (let i = 0; i < saved.visited.length - 1; i++) {
    if (trial.current.id !== saved.visited[i]) return false;
    const result = trial.next(saved.answers?.[trial.current.id]);
    if (!result.ok || trial.current.id !== saved.visited[i + 1]) return false;
  }
  if (trial.current.id !== saved.flowScreen) return false;
  for (let i = 0; i < saved.visited.length - 1; i++) flow.next(saved.answers?.[flow.current.id]);
  return true;
}

async function restoreAnnualJourney({app, flow, definition, config, sdk, restoreFields = true, storage = window.sessionStorage}) {
  if (window.Shopify?.designMode) return null;
  const key = 'pg:annual-return:' + config.quizKey + ':' + config.versionKey;
  try {
    let raw = storage.getItem(key);let migrated=false;if(!raw){raw=storage.getItem('pg:annual-return:'+config.quizKey+':pg-ed26b6850ac8868c');migrated=!!raw;}
    if (!raw || raw.length > 100000) return null;
    const saved = JSON.parse(raw);
    const validScreen = definition.screens.some(screen => screen.id === saved.flowScreen)
      && (saved.screen === saved.flowScreen || (config.completeScreens.includes(saved.screen) && definition.screens.find(screen => screen.id === saved.flowScreen)?.terminal));
    if (!Number.isFinite(saved.savedAt) || Date.now() - saved.savedAt > 30 * 60 * 1000 || saved.savedAt > Date.now() || !validScreen) { storage.removeItem(key); return null; }
    await sdk.init({quizKey:config.quizKey,versionKey:config.versionKey,endpoint:config.endpoint||'https://growth.nysonik.com',landingUrl:config.sourceUrl});
    if ((!migrated && (!saved.sessionId || sdk.getSessionId() !== saved.sessionId)) || !replayAnnualJourney(flow, definition, saved)) { storage.removeItem(key); return null; }
    if(migrated){saved.sessionId=sdk.getSessionId();storage.setItem(key,JSON.stringify(saved));}
    if (restoreFields) restoreQuizJourneyFields({app, saved});
    app.dataset.annualReturnScreen = saved.screen;
    return saved;
  } catch { return null; }
}

function saveAnnualJourney({app, flow, sdk, quizKey, versionKey, screen, storage = window.sessionStorage}) {
  if (!sdk.getSessionId() || !flow.current.terminal) throw new Error('Your completed plan could not be saved. Please try again.');
  saveQuizJourney({app, flow, sdk, quizKey, versionKey, screen, storage});
}

function saveQuizJourney({app, flow, sdk, quizKey, versionKey, screen = flow.current.id, storage = window.sessionStorage}) {
  const sessionId = sdk.getSessionId();
  if (!sessionId) return false;
  const saved = {
    schema:3, savedAt:Date.now(), sessionId, screen, flowScreen:flow.current.id, visited:flow.visited, answers:flow.answers,
    fields:[...app.querySelectorAll(journeyFields())].map((f,index)=>({index,value:'value' in f?f.value:undefined,checked:'checked' in f?f.checked:undefined,pressed:f.getAttribute('aria-pressed'),ariaChecked:f.getAttribute('aria-checked'),ariaSelected:f.getAttribute('aria-selected'),hidden:f.matches?.('[data-multi-footer]')?f.hidden:undefined,disabled:f.matches?.('[data-flow-next]')?f.disabled:undefined,attributes:Object.fromEntries(['placeholder','maxlength','aria-label'].map(name=>[name,f.getAttribute(name)]))})),
    units:[...app.querySelectorAll('[data-flow-screen][data-unit]')].map(p=>({screen:p.dataset.flowScreen,unit:p.dataset.unit})),
    decorations:journeyDecorations(app).map(({panel,labels,hidden})=>({screen:panel.dataset.flowScreen,labels:labels.map(label=>({text:label.textContent,original:label.dataset.original})),hidden:hidden.map(node=>node.hidden)})),
  };
  try { storage.setItem('pg:annual-return:' + quizKey + ':' + versionKey, JSON.stringify(saved)); }
  catch { throw new Error('Allow session storage so your completed plan can be restored after checkout.'); }
  return true;
}

/** Bind after the renderer. Restore before constructing the analytics bridge,
 * so replaying saved transitions never emits answer events. */
function bindQuizJourney({app, flow, sdk, config, bridge, env = window}) {
  if (env.Shopify?.designMode || app.__pgJourneyBound) return;
  app.__pgJourneyBound = true;
  const persist = () => {
    try {
      saveQuizJourney({app, flow, sdk, ...config, screen:app.dataset.currentScreen || flow.current.id, storage:env.sessionStorage});
    } catch {
      env.dispatchEvent(new env.CustomEvent('nyquiz:health', {detail:{status:'degraded',reason:'quiz_progress_storage_unavailable'}}));
    }
  };
  const show = bridge.show.bind(bridge);
  bridge.show = id => { show(id); persist(); };
  for (const event of ['input','change','click']) app.addEventListener(event, () => env.queueMicrotask(persist));
  // Initialization may finish after the first interaction. Save the latest
  // state when the collector has established this tab's visit ownership.
  Promise.resolve(sdk.init({quizKey:config.quizKey,versionKey:config.versionKey,endpoint:config.endpoint||'https://growth.nysonik.com',landingUrl:config.sourceUrl})).then(persist).catch(() => {});
}
// An optional upcoming occasion can be skipped, but not set to a past or
// impossible calendar date. Compare calendar days in the visitor's timezone.
function quizEventDateError(value, today = new Date()) {
  if (value === '' || value == null) return null;
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value));
  if (!match) return 'Enter a valid event date.';
  const [,year,month,day] = match.map(Number);
  const date = new Date(year,month-1,day);
  if (date.getFullYear()!==year || date.getMonth()!==month-1 || date.getDate()!==day) return 'Enter a valid event date.';
  const start = new Date(today.getFullYear(),today.getMonth(),today.getDate());
  return date < start ? 'Choose today or a future event date, or skip this question.' : null;
}

bindAnnualCheckout({app,sdk:window.NyQuiz,quizKey:"pg-lasta",versionKey:"pg-06dce696b2a583f0",checkoutFactory:createAnnualCheckout,saveJourney:screen=>saveAnnualJourney({app,flow,sdk:window.NyQuiz,quizKey:"pg-lasta",versionKey:"pg-06dce696b2a583f0",screen}),designMode:!!window.Shopify?.designMode});

bindQuizJourney({app,flow,sdk:window.NyQuiz,config:annualResumeConfig,bridge:pgAnalytics});

// Scoped FM17 overlay. Existing collector, checkout integration and assets stay unchanged.
function setupFm17Headers(){
 for(const p of panels){
  const header=p.querySelector('header,.progress');if(!header)continue;
  header.classList.add('fm17-header');
  for(const e of header.querySelectorAll('[data-flow-menu],.header-right,a[href*="contact"],a[href*="support"]'))e.remove();
  for(const image of header.querySelectorAll('img'))image.remove();
  const logo=document.createElement('img');logo.src=app.dataset.fm17Logo;logo.alt='Flo';logo.className='fm17-logo';logo.width=57;logo.height=50;header.append(logo);
  if(header.classList.contains('lf-header'))header.classList.add('fm17-offer-header');
  else {
   const progress=[...header.children].find(x=>x.classList.contains('absolute'));
   if(progress)progress.classList.add('fm17-progress');
   const back=header.querySelector('[data-flow-back]');if(back)back.classList.add('fm17-back');
  }
 }
}
function fm17Recommendation(a){
 const goals=(a.s03||[]).map(x=>({o1:'work toward losing weight',o2:'improve your fitness',o3:'feel firmer and more toned',o4:'build a consistent routine'})[x]).filter(Boolean);
 const experience=({o1:'You practice Pilates regularly, so choose sessions that fit your current level.',o2:'You have tried Pilates before, so start with familiar movements and build from there.',o3:'You are new to Pilates, so begin with the beginner sessions and learn the cues at your own pace.'})[a.s08];
 return [goals.length?'You want to '+goals.join(' and ')+'.':null,experience].filter(Boolean).join(' ')||'Explore guided Mat Pilates workouts you can follow at home. Choose a starting level that feels manageable for you.';
}
function fm17PlanReady(id){
 if(id!=='s27')return;
 const p=panels.find(x=>x.dataset.flowScreen===id),heading=p.querySelector('.graf-header');
 if(heading)heading.textContent=(flow.answers.s23?flow.answers.s23+', your':'Your')+' Mat Pilates starting point is ready. See how to begin with guided workouts at home.';
 let reassurance=p.querySelector('[data-fm17-result-guarantee]');if(!reassurance){reassurance=document.createElement('p');reassurance.dataset.fm17ResultGuarantee='';reassurance.className='fm17-offer-intro';reassurance.textContent='99-Day Results Guarantee';p.querySelector('[data-flow-next]')?.parentElement.before(reassurance);}
}
function fm17Offer(p,id){
 if(app.__fm17Timer)clearInterval(app.__fm17Timer);
 if(!['s28'].includes(id))return;
 const intro=p.querySelector('[data-fm17-offer-intro]');if(intro)intro.textContent=fm17Recommendation(flow.answers)+sq18LastaRoutine(flow.answers);
 const title=p.querySelector('[data-fm17-offer-title]');if(title)title.textContent='Flo Pilates: 28-Day Sculpt and Tone Mat-Pilates Program';
 const header=p.querySelector('.lf-header__inner');if(!header)return;
 let clock=header.querySelector('[data-fm17-clock]');
 if(!clock){clock=document.createElement('div');clock.dataset.fm17Clock='';clock.className='fm17-clock';clock.innerHTML='<span>YOUR PLAN</span><strong data-fm17-time></strong>';header.prepend(clock);}
 // A tab/session-local deadline begins at offer entry, never during quiz loading.
 const offerSession=window.NyQuiz?.getSessionId?.()||'untracked';
 const key='pg:offer-deadline:'+annualResumeConfig.quizKey+':'+annualResumeConfig.versionKey+':'+offerSession;
 let deadline=app.__fm17Deadline;
 try{const stored=Number(sessionStorage.getItem(key));if(Number.isFinite(stored)&&stored>0)deadline=stored;}catch{}
 if(!deadline){deadline=Date.now()+600000;try{sessionStorage.setItem(key,String(deadline));}catch{}}
 app.__fm17Deadline=deadline;
 const tick=()=>{const seconds=Math.max(0,Math.ceil((deadline-Date.now())/1000));clock.hidden=seconds===0;clock.querySelector('[data-fm17-time]').textContent=String(Math.floor(seconds/60)).padStart(2,'0')+':'+String(seconds%60).padStart(2,'0');if(!seconds)clearInterval(app.__fm17Timer);};
 tick();app.__fm17Timer=setInterval(tick,250);
}


function sq18LastaRoutine(a){return ({never:' You are not exercising yet, so start with one manageable guided session.',rarely:' You rarely exercise, so begin with short, manageable sessions.'})[a.s12]||'';}

